import {auth} from '@common/auth/use-auth';
import {premiumQueries} from './premium-queries';
import {queryClient} from '@common/http/query-client';
import {redirect, RouteObject} from 'react-router';
import {setInLocalStorage} from '@ui/utils/hooks/local-storage';

/*
check file common/foundation/resources/client/auth/use-auth.ts line 138
*/

export const premiumPageRoutes: RouteObject[] = [
  {
    path: 'premium',
    lazy: () => import('@common/premium/premium-page/plan-page/plan-page'),
    loader: () => {
      if (!auth.isLoggedIn) {
        setInLocalStorage('redirect_uri', '/premium');
        return redirect('/register?redirectFrom=premium');
      }

      queryClient.ensureQueryData(premiumQueries.plans.index('premiumPage'));
    },
  },

  // msap, exp -> http://{hostname}/sms/37162836127362183
  // -> file resoucess/client/homepage.tsx line 17
  {
    path: 'sms/:smscode',
    loader: ({params}) => {
      console.log('-> params:', params.smscode!);
      if (!auth.isLoggedIn) {
        setInLocalStorage('activation', {smscode: params.smscode!});
        return redirect('/register?redirectFrom=smscode');
      }

      setInLocalStorage('activation', {smscode: params.smscode!});
      return redirect('/');
    },
  },
];
